import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import ReportMisuseForm from './ReportMisuseForm'

export default function index() {
  return (
    <div>
        <Header/>
        <ReportMisuseForm/>
        <Footer/>
    </div>
  )
}
